const SLUG_KEYS = [
  "slug",
  "property_type_slug",
  "property_category_slug",
  "property_subcategory_slug",
  "type_slug",
  "category_slug",
  "subcategory_slug",
];

export const getEntitySlug = (entity) => {
  if (!entity || typeof entity !== "object") return "";

  for (const key of SLUG_KEYS) {
    if (entity[key]) {
      return entity[key];
    }
  }

  return entity?.id !== undefined && entity?.id !== null ? String(entity.id) : "";
};

const matchesSelection = (entity, selection) => {
  if (!entity || selection === undefined || selection === null || selection === "") {
    return false;
  }

  const selectionValue = String(selection);
  const candidateValues = [
    entity?.id,
    entity?.slug,
    entity?.property_type_slug,
    entity?.property_category_slug,
    entity?.property_subcategory_slug,
    entity?.type_slug,
    entity?.category_slug,
    entity?.subcategory_slug,
  ]
    .filter((value) => value !== undefined && value !== null && value !== "")
    .map((value) => String(value));

  return candidateValues.includes(selectionValue);
};

export const resolveSelectionSlug = (items = [], selection) => {
  if (selection && typeof selection === "object") {
    return getEntitySlug(selection);
  }

  const matchedItem = (items || []).find((item) => matchesSelection(item, selection));
  return getEntitySlug(matchedItem) || (selection !== undefined && selection !== null ? String(selection) : "");
};

export const resolvePropertyTypeSlug = (propertyTypes = [], selection) => {
  if (selection && typeof selection === "object") {
    return getEntitySlug(selection);
  }

  const normalizedSelection = String(selection || "").toLowerCase();
  const matchedItem = (propertyTypes || []).find((item) => {
    const label = String(item?.property_type || item?.property_type_title || "").toLowerCase();
    const slug = String(getEntitySlug(item)).toLowerCase();

    return slug === normalizedSelection || label === normalizedSelection || label.includes(normalizedSelection);
  });

  return getEntitySlug(matchedItem) || String(selection || "");
};

export const toPropertySelection = (entity) => {
  if (!entity || typeof entity !== "object") return entity;

  const slug = getEntitySlug(entity);

  return {
    ...entity,
    slug,
    property_type_slug: entity?.property_type_slug || slug,
    property_category_slug: entity?.property_category_slug || slug,
    property_subcategory_slug: entity?.property_subcategory_slug || slug,
  };
};
